import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.draggedItem = null
    this.savedOrder = this.currentOrder()
  }

  start(event) {
    const item = event.target.closest("[data-banner-id]")
    if (!item) return

    this.draggedItem = item
    item.classList.add("opacity-40")
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", item.dataset.bannerId)
  }

  over(event) {
    if (!this.draggedItem) return
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    const overItem = event.target.closest("[data-banner-id]")
    if (!overItem || overItem === this.draggedItem) return

    const rect = overItem.getBoundingClientRect()
    const dropAfter = event.clientY > rect.top + rect.height / 2
    if (dropAfter) {
      overItem.after(this.draggedItem)
    } else {
      overItem.before(this.draggedItem)
    }
  }

  drop(event) {
    event.preventDefault()
  }

  end(event) {
    if (this.draggedItem) {
      this.draggedItem.classList.remove("opacity-40")
      this.draggedItem = null
    }

    const order = this.currentOrder()
    if (order === this.savedOrder) return
    this.savedOrder = order

    fetch("/admin/banners/sort", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ order: order.split(",") })
    })
      .then(response => {
        if (!response.ok) throw new Error("Position save failed")
        this.refreshPositionLabels()
      })
      .catch(() => {
        alert("Could not save the new banner order. Please refresh the page and try again.")
      })
  }

  currentOrder() {
    return this.items().map(item => item.dataset.bannerId).join(",")
  }

  refreshPositionLabels() {
    this.items().forEach((item, index) => {
      const label = item.querySelector("[data-position-label]")
      if (label) label.textContent = `Position ${index + 1}`
    })
  }

  items() {
    return [...this.element.querySelectorAll("[data-banner-id]")]
  }
}
